import React, { useCallback, useMemo } from "react";
import { FilterShowcase } from "../../../../../../Components/FilterShowcase/filterShowcase.index";
import { useInsights } from "../../../../../../Context/insightContext";
import { useInsightsUtils } from "../../../../../../hooks/useInsightsUtils";
import { DEFAULT_INSIGHTS_UI_FILTERS } from "../../insightsHeader.constants";
import { InsightsUiFilters } from "../../insightsHeader.models";
import {
    buildInsightsFilterChips,
    sanitizeInsightsUiFilters,
    toInsightsCreatedOnRange,
    toInsightsFilterModels,
} from "../../insightsHeader.utils";

export const InsightsFilterShowcase = () => {
    const { insightsUiFilters, setInsightsUiFilters, filterInfoStatic } = useInsights();
    const { HandleFilterChange } = useInsightsUtils();
    const availableFilters = filterInfoStatic.current ?? [];

    const chips = useMemo(
        () => buildInsightsFilterChips(insightsUiFilters),
        [insightsUiFilters]
    );

    const applyFilters = useCallback(
        async (nextFilters: InsightsUiFilters) => {
            const filtersToApply = sanitizeInsightsUiFilters(nextFilters);
            const filterModels = toInsightsFilterModels(filtersToApply, availableFilters);
            const dateRange = toInsightsCreatedOnRange(filtersToApply);
            const didApply = await HandleFilterChange(filterModels, dateRange);
            if (didApply) {
                setInsightsUiFilters(filtersToApply);
            }
        },
        [availableFilters, HandleFilterChange, setInsightsUiFilters]
    );

    const handleClearAllFilters = async () => {
        await applyFilters(DEFAULT_INSIGHTS_UI_FILTERS);
    };

    const handleRemove = async (key: string) => {
        const nextFilters = { ...insightsUiFilters };
        delete nextFilters[key];
        await applyFilters(nextFilters);
    };

    if (!chips.length) return null;

    return (
        <FilterShowcase
            chips={chips}
            onRemove={handleRemove}
            onClearAll={handleClearAllFilters}
        />
    );
};
